import { render, staticRenderFns } from "./CurriculumReadMenuEECItem.vue?vue&type=template&id=415fe408&scoped=true&"
import script from "./CurriculumReadMenuEECItem.vue?vue&type=script&lang=ts&"
export * from "./CurriculumReadMenuEECItem.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumReadMenuEECItem.vue?vue&type=style&index=0&id=415fe408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fe408",
  null
  
)

export default component.exports